export default {"src":"/_next/static/media/0xab3f0245b83feb11d15aaffefd7ad465a59817ed.8d8e3ad1.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};